module.exports = __webpack_public_path__ + "static/media/workbrook_logo.30cded43.svg";